import { GET_ACCESS_GROUP_VALUE_SUCCESS, UPDATE_ACCESS_GROUP_VALUE, UPDATE_ACCESS_GROUP_VALUE_SUCCESS } from "./actiontype"


const initialState = {
  updateaccessgroup:null
}

const accessgroup = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCESS_GROUP_VALUE_SUCCESS:
      state = {
        ...state,
        accessgrouplist: action.payload,
      }
      break
      case UPDATE_ACCESS_GROUP_VALUE:
        state = {
          ...state,
          updateaccessgroup: null,
          updateaccessgroupError: null,
          
        }
        break
    case UPDATE_ACCESS_GROUP_VALUE_SUCCESS:
      state = {
        ...state,
        updateaccessgroup: action.payload,
        updateaccessgroupError: null,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default accessgroup
